import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const propTypes = {
    children: PropTypes.node,
    error: PropTypes.bool,
    onSubmit: PropTypes.func
};

const defaultProps = {
    children: null,
    error: false,
    onSubmit: null
};

const useStyles = makeStyles((theme) => styles(theme));

function AuthBody ({ error, onSubmit, children }) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={error ? classes.cardWrapperError : classes.cardWrapper}>
                <form className={classes.card} onSubmit={onSubmit}>
                    {children}
                </form>
            </div>
        </div>
    );
}

const styles = (theme) => ({
    root: {
        width: '100%',
        height: `calc(100vh - ${theme.constants.header}px)`,
        backgroundImage: 'url(\'https://images.landhawk.uk/overlays/login-bg.jpg\')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        display: 'grid',
        placeItems: 'center'
    },
    cardWrapper: {
        background: 'linear-gradient(270deg, #A9FE95 0%, #9ED6DE 100%)',
        paddingTop: '20px'
    },
    cardWrapperError: {
        background: 'linear-gradient(270deg, #FFE5A0 0%, #FF7981 100%)',
        paddingTop: '20px'
    },
    card: {
        width: '700px',
        background: theme.palette.background.contrastText,
        padding: `
            ${theme.constants.auth.verticalMargin}px  
            ${theme.constants.auth.horizontalMargin}px  
            ${theme.constants.auth.verticalMargin + 15}px  
            ${theme.constants.auth.horizontalMargin}px
        `,
        boxSizing: 'border-box',
        // ['@media (max-height: 1100px)']: {
        //     padding: '40px 60px',
        //     width: '600px'
        // }
        '& > *:not(:last-child)': {
            marginBottom: theme.constants.auth.verticalMargin * 0.5
        }
    }
});

AuthBody.propTypes = propTypes;
AuthBody.defaultProps = defaultProps;

export default AuthBody;